import TLoginInvitedUserPassword from './index.vue';

TLoginInvitedUserPassword.install = app => {
  app.component(TLoginInvitedUserPassword.name, TLoginInvitedUserPassword);
};

export default TLoginInvitedUserPassword;
